var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"my-faq"},[_vm._v(_vm._s(_vm.$t('FAQ')))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.dataset)}})])}
var staticRenderFns = []

export { render, staticRenderFns }